<template>
    <div id="app1">
        <headerTop></headerTop>
        <banner></banner>
        <div class="container" >
            <router-view></router-view>
        </div>
        <div class="footer_con" style="">
        <foot></foot>
        </div>
        <chatWindow/>
    </div>
</template>

<script>
import banner from '../components/Banner.vue'
import foot from '../components/Footer.vue'
import headerTop from '../components/Header.vue'
import chatWindow from '../components/chat/chatWindow.vue';
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页',
                sliders: [],
                menu:[
                    {menu:'首页',index:'1',submenu:[
                        
                    ]},
                    {menu:'产品中心',index:'2',submenu:[
                        {index:'2-1',title:'投标保函'},
                        {index:'2-2',title:'合同履约保函'},
                        {index:'2-3',title:'工程款支付保函'},
                        {index:'2-4',title:'预付款保函'},
                        {index:'2-5',title:'工程质量保函'},
                        {index:'2-6',title:'农民工工资支付保函'},
                    ]},
                    {menu:'合作机构',index:'3',submenu:[]},
                    {menu:'关于我们',index:'4',submenu:[
                        {index:'4-1',title:'公司简介'},
                        {index:'4-2',title:'商务合作'},
                        {index:'4-3',title:'联系我们'},
                        // {index:'4-4',title:'意见反馈'},
                    ]},
                    {menu:'相关资讯',index:'5',submenu:[
                        {index:'5-1',title:'公司动态'},
                        {index:'5-2',title:'政策解读'},
                        {index:'5-3',title:'行业资讯'},
                        {index:'5-4',title:'干货分享'},
                        {index:'5-5',title:'时事热点'},
                        /*{index:'5-6',title:'收费标准'},*/ // todo
                    ]},
                    {menu:'保函服务',index:'6',submenu:[
                        {index:'6-1',title:'保函查验'},
                        {index:'6-2',title:'理赔申请'},
                    ]},
                    {menu:'信用公示',index:'7',submenu:[
                        {index:'7-1',title:'平台信用公示'},
                        {index:'7-2',title:'查询入口'},
                       
                    ]},
                    {menu:'帮助中心',index:'8',submenu:[]},
                ]
            };
        },
        components:{
            banner,
            foot,
            headerTop,
          chatWindow
        },
        mounted() {
            this.sliders = [
               
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
        methods: {
            handleSelect(key) {
               
                let tabIndex;
                let index = key.indexOf('-');
                let menuIndex ;
                if(index!=-1){
                    tabIndex = key.slice(index+1)
                    menuIndex =key.slice(0,index) ;
                }else{
                    tabIndex = ''
                    menuIndex = key;
                }
                console.log('layout',menuIndex,index,tabIndex)
                this.$forceUpdate()
                switch (menuIndex){
                    case '1':
                        this.$router.push({path: "/pc"});
                        break;
                    case '2':
                        this.$router.push({path: "/pc/produce",query:{tabIndex:tabIndex}});
                        break;
                    case '3':
                        this.$router.push({path: "/pc/partner",query:{tabIndex:tabIndex}});
                        break;
                    case '4':
                        this.$router.push({path: "/pc/about",query:{tabIndex:tabIndex}});
                        break;
                    case '5':
                        this.$router.push({path: "/pc/news",query:{tabIndex:tabIndex}});
                        break;
                    case '6':
                        this.$router.push({path: "/pc/service",query:{tabIndex:tabIndex}});
                        break;
                    case '7':
                        this.$router.push({path: "/pc/credit",query:{tabIndex:tabIndex}});
                        break;
                }
            },
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2-1':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品微观";
                        this.currentMenu='首页';
                        break;
                    case '2-2':
                        this.$router.push({name: "Fruit"});
                        this.currentMenu='生鲜果蔬';
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        this.currentMenu='首页';
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        this.currentMenu='首页';
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        this.currentMenu='首页';
                        break;
                }
            },
            // handleScroll(){
            //     this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            //     if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
            //         this.$refs.btn.style.display = 'block';
            //     }else{
            //         this.$refs.btn.style.display = 'none'
            //     }
            // },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                window.open('https://tb.dinghanwang.com/login')
            },
            register(){
                window.open('https://admin.fastice-tech.com/registe')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
        // mounted() {
        //     this.menuSeen()
        //     window.addEventListener('scroll', this.handleScroll)
        // },
    }
</script>

<style scoped>
    #app1{
        min-width: 1200px;
    }
    .container{
        min-width: 1200px;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .footer_con{
        width:100%;
        height: 644px;
        background-image: linear-gradient(#b4e0f9, #6cb1ff);
    }
    
</style>
